import styled from 'styled-components';

const Root = styled.div `
  /* Additional 4px margin for 8px in total */
  .tend-ui-checkbox-group,
  .tend-ui-toggle-group,
  .tend-ui-radio-group {
    margin-top: 4px;
  }
`;

export { Root };
//# sourceMappingURL=styled.js.map
